import logo from '../assets/logo.png';
import React from 'react';

const HomePage = () => (
  <div className="home-container">
    <div className="img-div">
      <img className="main-logo" src={logo} alt="my logo" />
    </div>
    <div className="stack-intro">
      <div className="my-intro">
        <h3> Hey, </h3>
        <h3> I'm Iddrisu Salley </h3>
        <p> Software Engineer </p>
      </div>
      <div className="stack-section">
        <div className="line">
          <div className="dot">
            <div className="inner-dot"></div>
          </div>
          <div className="dot">
            <div className="inner-dot"></div>
          </div>
        </div>
        <div className="discription">
          <p className="intro-msg">
            "I design and build Web and Mobile applications, high performing and
            responsive."
          </p>
          <div className="stack-three">
            <h3 className="section-title">STACK</h3>
            <p className="stack-title">Front-end </p>
            <p className="small">
              JavaScript, Vue, React, React-Native, Nextjs, Redux, JQuery, HTML5, CSS3, Sass,
              Tailwindcss, Bootstrap, Bulma.
            </p>
            <p className="stack-title">Back-end </p>
            <p className="small">Ruby, Rails, Go, Nodejs, MySQL.</p>
            <p className="stack-title">TOOLS &#38; METHODS</p>

            <p className="small">
              Git, GitHub, Heroku, Netlify, Theme Ui, Mobile/Responsive, Firestore,AWS,
              Development, RSpec, TDD, Chrome Dev Tools.{' '}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/HomePage.js